import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import Typography from '@material-ui/core/Typography'

import InputAdornment from '@material-ui/core/InputAdornment'
import Person from '@material-ui/icons/Person'

import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import SessionStyles from '../../styles/Session'

import Snackbar from '@material-ui/core/Snackbar'
import SnackbarWrapper from '../../containers/SnackbarWrapper'

import { handleSignUp } from '../../actions/authedUser'

import t from '../../utils/lang/user'

class SignUp extends Component {
  state = {
    company: '',
    firstName: '',
    lastName: '',
    jobTitle: '',
    email: '',
    phone: '',
    password: '',
    repeatPassword: '',
    isEmailSent: false,
    snackbarOpen: false,
    snackMessage: ''
  }

  handleChangeCompany = (e) => {
    const company = e.target.value

    this.setState(() => ({
      company
    }))
  }

  handleChangeFirstName = e => {
    const firstName = e.target.value

    this.setState(() => ({
      firstName
    }))
  }

  handleChangeLastName = e => {
    const lastName = e.target.value

    this.setState(() => ({
      lastName
    }))
  }

  handleChangeJobTitle = e => {
    const jobTitle = e.target.value

    this.setState(() => ({
      jobTitle
    }))
  }

  handleChangeEmail = e => {
    const email = e.target.value

    this.setState(() => ({
      email
    }))
  }

  handleChangePhone = e => {
    const phone = e.target.value

    this.setState(() => ({
      phone
    }))
  }

  handleChangePassword = e => {
    const password = e.target.value

    this.setState(() => ({
      password
    }))
  }

  handleChangeRepeatPassword = e => {
    const repeatPassword = e.target.value

    this.setState(() => ({
      repeatPassword
    }))
  }

  handleSignUpForm = e => {
    e.preventDefault()

    const { dispatch } = this.props
    const { company, firstName, lastName, jobTitle, email, phone, password, repeatPassword } = this.state

    if (password !== repeatPassword) {
      this.setState({ snackMessage: 'Passwords do not match.' })
      this.handleOpenSnackbar()

    } else {
      const data = {
        company,
        firstName,
        lastName,
        jobTitle,
        email,
        phone,
        password
      }

      dispatch(handleSignUp(data))
        .then((res) => {
          console.log(res)
          if (res.status === 0) {
            this.setState({ snackMessage: res.message })
            if (this.state.snackMessage !== '') {
              this.handleOpenSnackbar()
            }

          } else if (res.status === 1) {
            this.setState({isEmailSent: true})
          }
        })
    }
  }

  handleOpenSnackbar = () => {
    this.setState({ snackbarOpen: true })
  }

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false })
  }

  render() {
    const { classes } = this.props
    const { snackMessage, isEmailSent, company, firstName, lastName, jobTitle, email, phone, password, repeatPassword } = this.state
    const lang = 'en'

    return (
      <div className={classNames(classes.session, classes.background)}>
        <div className={classes.content}>
          <div className={classes.wrapper}>
            <Card>
              <CardContent>
                <form onSubmit={this.handleSignUpForm}>
                  <div className="text-xs-center pb-xs">
                    <img src="/static/images/logo.svg" alt=""/>
                    <Typography className={classes.accountInfo}>Create your FlexHub account. Please fill out all the fields to accelerate the verification process.</Typography>
                  </div>

                  {!isEmailSent
                    ? <Fragment>
                        <FormControl className={classes.formControl}>
                          <TextField
                            id="company"
                            label={t[lang].company}
                            value={company}
                            onChange={this.handleChangeCompany}
                          />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                          <TextField
                            id="firstName"
                            label={t[lang].firstName}
                            value={firstName}
                            onChange={this.handleChangeFirstName}
                          />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                          <TextField
                            id="lastName"
                            label={t[lang].lastName}
                            value={lastName}
                            onChange={this.handleChangeLastName}
                          />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                          <TextField
                            id="jobTitle"
                            label={t[lang].jobTitle}
                            value={jobTitle}
                            onChange={this.handleChangeJobTitle}
                          />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                          <TextField
                            id="email"
                            label={t[lang].email}
                            value={email}
                            type="email"
                            onChange={this.handleChangeEmail}
                          />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                          <TextField
                            id="phone"
                            label={t[lang].phone}
                            value={phone}
                            type="phone"
                            onChange={this.handleChangePhone}
                          />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                          <TextField
                            id="password"
                            label={t[lang].password}
                            value={password}
                            type="password"
                            onChange={this.handleChangePassword}
                          />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                          <TextField
                            id="repeatPassword"
                            label={t[lang].repeatPassword}
                            value={repeatPassword}
                            type="password"
                            onChange={this.handleChangeRepeatPassword}
                          />
                        </FormControl>
                        <Button variant="raised" color="secondary" fullWidth type="submit" disabled={company === '' || firstName === '' || lastName === '' || email === '' || phone === '' || password === '' || repeatPassword === ''} className={classes.signinButton}>Create account</Button>
                      </Fragment>
                    : <Typography className={classes.resultInfo}>Thank you for creating the account. We will contact you shortly to verify your data and help you set your account.</Typography>}

                  <div className="pt-1 text-md-center">
                    <Link to="/" className={classes.linkButton}>
                      <Button>Sign in</Button>
                    </Link>
                    <Link to="/forgot">
                      <Button>Forgot password?</Button>
                    </Link>
                  </div>
                </form>
              </CardContent>

              <Snackbar
                open={this.state.snackbarOpen}
                autoHideDuration={6000}
                onClose={this.handleCloseSnackbar}
                className={classes.snackbar}
              >
                <SnackbarWrapper
                  onClose={this.handleCloseSnackbar}
                  variant="error"
                  message={snackMessage}
                />
              </Snackbar>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

SignUp.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect()(withStyles(SessionStyles)(SignUp))


// WEBPACK FOOTER //
// ./src/components/Authentication/SignUp.js